import { useState } from 'react';
import { useAuth } from '../firebase/useAuth';
import styles from './SignInScreen.module.css';

export default function SignInScreen() {
  const { signInWithGoogle, signInWithEmail, signUpWithEmail, resetPassword } = useAuth();
  const [mode, setMode] = useState('signin'); // 'signin' | 'signup' | 'reset'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState('');
  const [resetSent, setResetSent] = useState(false);

  const handleGoogle = async () => {
    setError('');
    try {
      await signInWithGoogle();
    } catch (e) {
      setError(e.message);
    }
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      if (mode === 'reset') {
        await resetPassword(email);
        setResetSent(true);
      } else if (mode === 'signup') {
        await signUpWithEmail(email, password, displayName);
      } else {
        await signInWithEmail(email, password);
      }
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>Creativity</h1>
        <p className={styles.subtitle}>Daily prompts to spark your ideas.</p>

        <button className={styles.googleBtn} onClick={handleGoogle}>
          Continue with Google
        </button>

        <div className={styles.divider}><span>or</span></div>

        {resetSent ? (
          <p className={styles.resetConfirm}>Check your email for a reset link.</p>
        ) : (
          <form onSubmit={handleEmailSubmit} className={styles.form}>
            {mode === 'signup' && (
              <input
                className={styles.input}
                type="text"
                placeholder="Your name"
                value={displayName}
                onChange={e => setDisplayName(e.target.value)}
                required
              />
            )}
            <input
              className={styles.input}
              type="email"
              placeholder="Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
            {mode !== 'reset' && (
              <input
                className={styles.input}
                type="password"
                placeholder="Password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
            )}
            {error && <p className={styles.error}>{error}</p>}
            <button className={styles.submitBtn} type="submit">
              {mode === 'signin' ? 'Sign in' : mode === 'signup' ? 'Create account' : 'Send reset link'}
            </button>
          </form>
        )}

        <div className={styles.modeLinks}>
          {mode === 'signin' && (
            <>
              <button onClick={() => setMode('signup')}>Create account</button>
              <button onClick={() => setMode('reset')}>Forgot password?</button>
            </>
          )}
          {mode !== 'signin' && (
            <button onClick={() => { setMode('signin'); setResetSent(false); }}>Back to sign in</button>
          )}
        </div>
      </div>
    </div>
  );
}
